<div class="get-it-modal-dialog p-4" data-automation-id="get-it-modal-dialog">
  <div class="offers-box offeravailable">
    <div class="data-box">
      <img class="icon" src="../../../../assets/offers-box.svg" />
      <p class="text bold">Get a physical copy</p>
      <p class="text">
        Delivered in <span class="bold">{{ offer.supplyTime }} days</span>
      </p>
      <p class="text">
        Keep for <span class="bold">{{ offer.loanPeriod }} days</span>
      </p>
    </div>

    <button
      class="ins-buttons no-border button-primary flint w-100"
      data-automation-id="place-hold-btn"
      translate
      (click)="onGetIt($event)"
      [attr.aria-describedby]="'get-offers-button'"
    >
      {{ "request" | translate }}
    </button>
  </div>
</div>
